import { FunctionalComponent, h } from '@stencil/core';
import { AppLink } from './'

interface SectionFooter {
  data?: any;
}

export const SectionFooter: FunctionalComponent<SectionFooter> = ({ data }) => {

  if (!data) return;

  const { AddressLine, CompanyName, CompanyReg, Links, Social, SocialTitle, VAT, ContactTitle, ContactLinks } = data;

  const getCopyright = (company) => {
    return <span><span style={{ 'font-family': 'tahoma' }}>© </span>{`${new Date().getFullYear()} ${company}`}</span>
  }


  return (
    <footer class="uk-section uk-padding-remove-bottom uk-position-relative uk-background-primary-striped uk-light">
      <div class="uk-container uk-position-relative">
        <div class="uk-child-width-1-1 uk-child-width-1-2@m" uk-grid>
          <div class="uk-flex-last@m">
            <div>
              <h4 class="uk-heading-medium wsio-gold">{SocialTitle}</h4>
              <div class="uk-flex@s uk-flex-wrap">
                {Social.map((Link) => <AppLink className="uk-button uk-button-link uk-flex uk-flex-middle uk-margin-medium-right" data={Link} />)}
              </div>
              <h4 class="uk-margin-medium-top uk-heading-medium wsio-gold" style={{ 'text-trainsform': 'underline' }}>{ContactTitle}</h4>
              <div class="uk-flex@s uk-flex-wrap">
                {
                  ContactLinks.map((btn) => <AppLink className={`uk-button uk-button-link uk-button uk-button-link uk-flex uk-flex-middle uk-margin-medium-right ${btn.Icon == 'mail' ? 'uk-text-lowercase' : ''}`} data={btn} />)
                }
              </div>
            </div>
          </div>
          <div>
            <h4 class="uk-margin-top uk-heading-medium uk-hidden@m wsio-gold">Quick Links</h4>
            <div class="uk-column-1-2@s uk-margin-medium-bottom">
              <ul class="uk-list uk-list-collapse">
                {Links.map((Link) => <li><AppLink className='uk-button uk-button-link uk-text-left' data={Link} /></li>)}
              </ul>
            </div>
          </div>
        </div>
        <hr class="uk-margin-medium-top uk-margin-remove-bottom" style={{ 'border-width': '2px' }} />
        <div class="uk-width-1-1 uk-flex@s uk-flex-top uk-margin-medium-bottom">
          <div class="uk-width-1-1 uk-width-2-3@s uk-flex@s">
            <div class="uk-width-1-2 uk-width-1-3@s uk-margin-medium-top uk-margin-medium-right">
              <img class="uk-width-1-1" data-src="/assets/images/howardson-light.svg" alt="Howardson Logo" uk-svg></img>
            </div>
            <div class="uk-width-large uk-margin-medium-top">
              <div>{AddressLine}</div>
              <div>{CompanyReg}</div>
              <div>{VAT}</div>
            </div>
          </div>
          <div class="uk-width-1-1 uk-width-1-3@s uk-margin-medium-top">
            <div class="uk-text-right@s uk-heading-small uk-margin-remove">{getCopyright(CompanyName)}</div>
          </div>
        </div>
      </div>
    </footer>
  )
};